import { Computer, SpeakerNotes } from "@material-ui/icons";
import React from "react";
import { RoomViewModel } from "../../model/RoomViewModel";
import CustomCard from "../common/CustomCard";
import { injectIntl, WithIntlProps } from "react-intl";
import { GetTranslation } from "../../translations/GetTranslation";

type RoomCardProps = {
  room: RoomViewModel;
  onClick?: (roomId: string) => void;
} & WithIntlProps<any>;

const RoomCard: React.FunctionComponent<RoomCardProps> = (props) => {
  const { intl, room, onClick } = props;
  const handleClick = () => onClick!(room.id);
  return (
    <CustomCard
      line1={room.isPcRoom ? <Computer /> : <SpeakerNotes />}
      line2={room.name}
      line3={room.floor}
      restLines={[room.numberOfSeats + GetTranslation(intl, "room.text.seats")]}
      onClick={handleClick}
    />
  );
};

export default injectIntl(RoomCard);
